
import React from "react";
const SuccessPopup = ({ onClose }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
      <div className="bg-white rounded-xl shadow-lg p-6 text-center w-[300px]">
        <div className="flex justify-center">
          <div className="bg-red-500 rounded-full p-4 mb-4">
            <svg
              className="w-8 h-8 text-white"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
            </svg>
          </div>
        </div>
        <p className="text-lg font-medium text-gray-800 mb-3">
          Fields Updated Successfully!!! ✅
        </p>
        <button
          className="bg-red-600 text-white px-5 py-2 rounded font-semibold hover:bg-red-700"
          onClick={onClose}
        >
          Done
        </button>
      </div>
    </div>
  );
};
export default SuccessPopup
